<!-- routify:options preload="proximity" -->
<script lang="ts">
  window["C"].APP_NAME = "supplier";
  window["C"].userUrl = "/api/supplier/user";
  window["C"].salesforceChatContext = "distributor";
  import bootstrap from "@modern/services/boot/bootstrap";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import LoggedInHeader from "@modern/components/supplier/LoggedInHeader.svelte";
  import Footer from "@shared/svelte/Components/Layout/Footer.svelte";
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import UserContext from "@modern/services/user_context";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { afterPageLoad, beforeUrlChange, page, url, goto } from "@roxi/routify";
  import { updatePageIds } from "@shared/services/event_tracking/page_id_tracking";
  import { onDestroy } from "svelte";

  const { trackPageView } = EventTracking;

  $: user = null;
  $: trueUser = null;

  let accountDisplayName = "";
  let trueUserDisplayName = "";

  $afterPageLoad(_page => {
    trackPageView();
    return true;
  });

  $beforeUrlChange((event, route) => {
    updatePageIds();
    return true;
  });

  let unsubscribe = () => {};
  const load = async function () {
    updatePageIds();
    await bootstrap({ $page, $url, $goto });
    unsubscribe = await UserContext.getStore().subscribe(value => {
      user = value.user;
      trueUser = value.trueUser;
      accountDisplayName = UserContext.userNameString(user);
      trueUserDisplayName = UserContext.userNameString(trueUser);
    });
  };

  onDestroy(() => {
    unsubscribe();
  });
</script>

{#await load()}
  <Spinner />
{:then}
  <div class="app-container">
    <LoggedInHeader {user} {trueUser} {accountDisplayName} {trueUserDisplayName} />
    <slot scoped={{ user: user }} />
    <FlashWrapper />
    <Footer />
  </div>
{/await}
